import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../i18n';

export function Page404() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      gap={2}
      p={4}
    >
      <Typography variant="h1" fontWeight={700} color="primary">
        {t.page404.title}
      </Typography>
      <Typography variant="h5" color="text.secondary">
        {t.page404.subtitle}
      </Typography>
      <Button
        variant="contained"
        onClick={() => navigate('/')}
        sx={{ mt: 2 }}
      >
        {t.page404.back}
      </Button>
    </Box>
  );
}
